import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import courier from "../../../../assets/imgs/services/nationals/courier.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import NationalDescription from "../../../../components/national-description/national-description";
import gold1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold01.svg"
import gold2Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold02.svg"
import gold3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold03.svg"
import condiciones1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones01.svg"
import condiciones2Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg"
import condiciones3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones03.svg"

import courier1Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier1.svg"
import courier2Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier2.svg"
import courier3Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier3.svg"
import courier4Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier4.svg"
import courier5Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier5.svg"
import courier6Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier6.svg"

function Courier() {
  const [tCourier] = useTranslation("courierPage");
  const [tSMetaData] = useTranslation("metaData");
  const idCourier = "407138e3-da91-4725-b44e-ce97858a0fc3";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[0]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[0]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idCourier}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"]
            .content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
            .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
            .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("mensajería.title")}</title>
        <meta name="description" content={tSMetaData("courier.description")} />
      </Helmet>

      <ImageHeader
        imgBackground={courier}
      />

      <div className="info-national-content">
        <NationalDescription 
          title={tCourier("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tCourier("header.quote-btn")}
          quoteProductID="btnQuoteCourier"
          contactSales={tCourier("header.contact-sales")}
          contactProductID="btnContactCourier"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tCourier("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tCourier("accordion-1.title")}
              content={
                accordion1
                  ? JSON.parse(accordion1) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tCourier("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />
          </div>
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tCourier("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={courier1Icon} /></div>
              <p>{tCourier("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={courier2Icon} /></div>
              <p>{tCourier("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={courier3Icon} /></div>
              <p>{tCourier("non-applicable-charges.item3")}</p>
            </div>
          </div>
        </div>

        <div className="more-info-box">
          <h5>{tCourier("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={courier4Icon} /></div>
              <p>{tCourier("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={courier5Icon} /></div>
              <p>{tCourier("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={courier6Icon} /></div>
              <p>{tCourier("additional-conditions.item3")}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Courier;